/** Period closing history + review (FR / AR) */
export const periodClosingHistoryModalFr = {
  title: 'Clôtures périodiques',
  subtitle: 'Semaine · Mois · Trimestre · Année (une seule fois par période)',
  noClosings: 'Aucune clôture périodique enregistrée',
  typeWeek: 'Semaine',
  typeMonth: 'Mois',
  typeQuarter: 'Trimestre',
  typeYear: 'Année',
  reviewPending: 'En attente de vérification',
  reviewApproved: 'Vérifié',
  reviewRejected: 'Rejeté',
  approve: 'Valider après recherche',
  approveConfirm:
    'Confirmer que cette période a été vérifiée ? La synchronisation reprendra si plus aucune période n’est en attente.',
  approveSuccess: 'Période validée — synchronisation autorisée',
  approveFailed: 'Impossible de valider la période',
  syncBlockedBanner:
    'Synchronisation suspendue : clôture périodique en attente de vérification ({{periods}}).',
  revenue: 'Revenus',
  expenses: 'Dépenses',
  payments: 'Paiements',
  net: 'Net',
  dailyCount: '{{count}} clôtures journalières',
  closedAt: 'Clôturé le',
  period: 'Période',
  close: 'Fermer',
  filterAll: 'Toutes',
  filterPending: 'À vérifier'
};

export const periodClosingHistoryModalAr = {
  title: 'الإغلاقات الدورية',
  subtitle: 'أسبوع · شهر · ربع · سنة (مرة واحدة لكل فترة)',
  noClosings: 'لا توجد إغلاقات دورية مسجلة',
  typeWeek: 'أسبوع',
  typeMonth: 'شهر',
  typeQuarter: 'ربع سنة',
  typeYear: 'سنة',
  reviewPending: 'بانتظار المراجعة',
  reviewApproved: 'تمت المراجعة',
  reviewRejected: 'مرفوض',
  approve: 'اعتماد بعد البحث',
  approveConfirm:
    'تأكيد أن هذه الفترة قد رُوجعت؟ ستُستأنف المزامنة إذا لم تبقَ فترات معلّقة.',
  approveSuccess: 'تم اعتماد الفترة — المزامنة مسموحة',
  approveFailed: 'تعذّر اعتماد الفترة',
  syncBlockedBanner:
    'المزامنة موقوفة: إغلاق دوري بانتظار المراجعة ({{periods}}).',
  revenue: 'الإيرادات',
  expenses: 'المصروفات',
  payments: 'المدفوعات',
  net: 'الصافي',
  dailyCount: '{{count}} إغلاق يومي',
  closedAt: 'أُغلق في',
  period: 'الفترة',
  close: 'إغلاق',
  filterAll: 'الكل',
  filterPending: 'للمراجعة'
};
